<template>
  <div class="not-found">
    <div justify="center">
      <img :src="require('../assets/forbidden.svg')" alt="forbidden-svg" />
      <v-alert dense prominent type="info">
        <strong>No cuentas con suficientes permisos para acceder a la aplicación.</strong>
      </v-alert>
    </div>
  </div>
</template>

<style lang="scss">
.not-found {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80%;
}
</style>

<script>

export default {
  name: "Forbidden",
  mounted() {
  },
};
</script>